import type {Components, Theme} from '@mui/material';

export const MuiTooltip = (theme: Theme): Components['MuiTooltip'] => ({
  styleOverrides: {
    tooltip: {
      background: theme.palette.negativeBg,
      color: theme.palette.onNegativeText,
      padding: theme.spacing(1),
      borderRadius: theme.shape.borderRadius * 1.5,
    },
    arrow: {
      '&::before': {
        backgroundColor: theme.palette.negativeBg,
      },
    },
  },
});
